import './scss/index.scss';
import { dcFactory } from 'dc';
import  AskAshWizardComponent  from './js/ask-ash-wizard.component';

dcFactory.register(AskAshWizardComponent);
